import { ArcElement, Chart as ChartJS, ChartOptions, Legend, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import React, { Component } from 'react';
import { ChartJsDataModel } from '../../../domain/chart/ChartDomains';

ChartJS.register(ArcElement, Tooltip, Legend);

class PieChartComponent extends Component<Props> {
  public render() {
    const { data, options } = this.props;
    return <Pie data={data} options={options}></Pie>;
  }
}

export default PieChartComponent;

interface Props {
  data: ChartJsDataModel;
  options?: ChartOptions;
}
